// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const fasGripDotsVertical: CreateIconOptions = {
  "displayName": "FASGripDotsVertical",
  "viewBox": "0, 0, 256, 512",
  "d": "M48 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM96 416A48 48 0 1 0 0 416a48 48 0 1 0 96 0zM208 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48 112a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM208 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
};
